export var BOOKING_STEPS_MAPPING = {
  ancillaries: 'ancillaries',
  guestDetails: 'guest-details',
  payment: 'payment',
  spf: 'spf'
};